import { jsxs as n, jsx as o } from "react/jsx-runtime";
const i = ({
  width: r,
  height: t,
  className: e
}) => /* @__PURE__ */ n(
  "svg",
  {
    className: e,
    fill: "none",
    height: t,
    viewBox: "0 0 20 20",
    width: r,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M12.9257 2.35938H7.07565C5.00065 2.35938 4.54232 3.39271 4.27565 4.65938L3.33398 9.16771H16.6673L15.7257 4.65938C15.459 3.39271 15.0007 2.35938 12.9257 2.35938Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M18.3253 16.516C18.4169 17.491 17.6336 18.3327 16.6336 18.3327H15.0669C14.1669 18.3327 14.0419 17.9493 13.8836 17.4743L13.7169 16.9744C13.4836 16.291 13.3336 15.8327 12.1336 15.8327H7.86693C6.66693 15.8327 6.49194 16.3494 6.2836 16.9744L6.11694 17.4743C5.9586 17.9493 5.8336 18.3327 4.9336 18.3327H3.36694C2.36694 18.3327 1.5836 17.491 1.67527 16.516L2.14194 11.441C2.2586 10.191 2.50027 9.16602 4.6836 9.16602H15.3169C17.5003 9.16602 17.7419 10.191 17.8586 11.441L18.3253 16.516Z",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M3.33333 6.66602H2.5",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M17.4993 6.66602H16.666",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M10 2.5V4.16667",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M8.75 4.16602H11.25",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M5 12.5H7.5",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M12.5 12.5H15",
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.25"
        }
      )
    ]
  }
);
export {
  i as Content
};
